import { render, staticRenderFns } from "./ImportArea.vue?vue&type=template&id=4ff993e6"
import script from "./ImportArea.vue?vue&type=script&lang=js"
export * from "./ImportArea.vue?vue&type=script&lang=js"
import style0 from "./ImportArea.vue?vue&type=style&index=0&id=4ff993e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports